<template>
  <div>
    <a-card :bordered="false" class="header-solid h-full mb-20" :bodyStyle="{ paddingTop: '12px' }">
      <template #title>
        <a-row type="flex">
          <a-col flex="auto">
            <h6>VEHICLE CALENDAR</h6>
            <p class="mb-10">The calendar shows a list of vehicle booking.</p>
            <a-tag class="mb-20" color="#3D8361" style="font-weight: 200"><a-icon type="pushpin" class="mr-10" />Vehicle Booking :: Approve , Success</a-tag>
          </a-col>
          <a-col flex="100px" class="">
            <a-radio-group size="small" :value="modeView" @change="handleChangeView">
              <a-radio-button value="calendar">
                <a-icon class="mr-5" type="calendar" />Calendar
              </a-radio-button>
              <a-radio-button value="table">
                <a-icon class="mr-5" type="table" />Table
              </a-radio-button>
            </a-radio-group>
          </a-col>
        </a-row>
      </template>

      <div v-if="modeView === 'calendar'">
        <a-spin :spinning="!isCalendarLoaded" size="large">
          <a-calendar :header-render="headerRender" @panelChange="onPanelChange" @select="onSelect" fullscreen
            class="small">
            <ul slot="dateCellRender" slot-scope="value" class="events">
              <li v-for="item in getListData(value)" :key="'cid' + item.keyID">
                <span style="font-size: 12px; font-weight: 700" class="font-weight-bold font-web mt-0 mb-0">
                  <a-avatar :size="15" style="background-color:#3D8361" icon="pushpin" />
                  {{ item.content.replace('Pick up & Drop off ','') }}
                </span>
              </li>
            </ul>
          </a-calendar>
        </a-spin>
      </div>
      <div v-if="modeView === 'table'">
        <tablelist />
      </div>
    </a-card>
  </div>
</template>

<script>
import tablelist from './tablelist.vue'
import { calendarMixin } from "@/mixins/calendarMixin";
export default {
  mixins: [calendarMixin],
  components:{
    tablelist
  },
  props: {
    arrDate: {
      type: Array,
      default: () => [],
    },
    logVehicleBooking: {
      type: Array,
      default: () => [],
    },
    isCalendarLoaded: {
      type: Boolean,
      default: () => true
    },
    startDateCalendar: {
      type: String,
    },
    endDateCalendar: {
      type: String,
    }
  },
  data() {
    return {
      modeView: 'calendar'
    };
  },
  methods: {
    handleChangeView(e) {
      this.modeView = e.target.value;
    },

    findEventInday(day, month, year, nameDate) {
      let listDataCalendar = [];
      let monthFormat = month.toString().length == 1 ? "0" + month.toString() : month.toString();
      let dayFormat = day.toString().length == 1 ? "0" + day.toString() : day.toString();
      let newDateFormat = `${dayFormat}-${monthFormat}-${year}`;

      // LogVehicle
      for (let i = 0; i < this.logVehicleBooking.length; i++) {
        const vehicleBooking = this.logVehicleBooking[i];
        if (
          newDateFormat >= this.moment(vehicleBooking.use_start).format("DD-MM-YYYY") &&
          newDateFormat <= this.moment(vehicleBooking.use_end).format("DD-MM-YYYY")
        ) {
          listDataCalendar.push({
            keyID: vehicleBooking.id,
            date: newDateFormat,
            type: "infoVehicleBooking",
            content: vehicleBooking.reason_detail.eng_detail,
            cType: "user-vehicle",
          });
        }
      }
      return listDataCalendar;
    },
    getListData(value) {
      this.isLoaded = false;
      let listData;
      listData = this.findEventInday(
        value.date(),
        Number.parseInt(value.month() + 1),
        value.year(),
        this.moment(value).format("dddd")
      )
      return listData || [];
    },
    onSelect(value) {
      let startDate = this.moment(this.startDateCalendar).format("YYYY-MM-DD")
      let endDate = this.moment(this.endDateCalendar).format("YYYY-MM-DD")
      let curDate = this.moment(value._d).format("YYYY-MM-DD")

      if (curDate >= startDate &&
        curDate <= endDate) {
        this.$emit("viewVehicleBooking", this.formatDate(value._d));
      }
    },
  },
};
</script>

<style lang="css" scoped>
.box-loading {
  max-height: max-content;
}

.div-isLoaded {
  text-align: center;
  border-radius: 4px;

  padding: 30px 50px;
  margin: 20px 0;
}

.events {
  list-style: none;
  margin: 0;
  padding: 0;
}

.events .ant-badge-status {
  overflow: hidden;
  white-space: nowrap;
  width: 100%;
  text-overflow: ellipsis;
  font-size: 12px;
}

.notes-month {
  text-align: center;
  font-size: 28px;
}

.notes-month section {
  font-size: 28px;
}


@media screen and (max-width: 600px) {
  .small {
    zoom: 65% !important;
  }
}
</style>